import React from 'react';
import { Instagram, Facebook, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gradient-to-r from-[#1e3a4a] via-[#1c587a] to-[#1976a3] text-white" data-id="element-60">
      <div className="container mx-auto px-4 py-12 md:py-16" data-id="element-61">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-62">
          {/* Brand */}
          <div data-id="element-63">
            <a href="#" className="inline-flex items-center mb-5" aria-label="Autopoint" data-id="element-64">
              <img src="https://cdn.magicpatterns.com/uploads/8W3K6WsSkda3SCEjPHenmx/AP_Logo.9c1472ca.svg" alt="Autopoint" className="h-8 w-auto" style={{
              filter: 'brightness(0) invert(1)'
            }} data-id="element-65" />
            </a>
            <p className="text-white/75 text-sm leading-relaxed mb-6" data-id="element-66">
              Autopoint je napredna platforma, posebej zasnovana za revolucijo
              načina, kako ljudje kupujejo in prodajajo avtomobile na dražbah.
            </p>
            <div className="flex items-center gap-2 mb-4" data-id="element-67">
              {[{
              code: 'gb',
              label: '🇬🇧'
            }, {
              code: 'si',
              label: '🇸🇮'
            }, {
              code: 'de',
              label: '🇩🇪'
            }, {
              code: 'hr',
              label: '🇭🇷'
            }, {
              code: 'rs',
              label: '🇷🇸'
            }].map(flag => <button key={flag.code} aria-label={flag.code} className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center text-sm" data-id="element-68">
                  {flag.label}
                </button>)}
            </div>
            <div className="flex items-center gap-3 text-xs text-white/50" data-id="element-69">
              <span data-id="element-70">1.2.1</span>
              <span className="text-white/30" data-id="element-71">|</span>
              <span data-id="element-72">1.3.1</span>
            </div>
          </div>

          {/* Platforma */}
          <div data-id="element-73">
            <h3 className="font-semibold mb-4" data-id="element-74">Platforma</h3>
            <ul className="space-y-3 text-sm" data-id="element-75">
              <li data-id="element-76">
                <a href="#" className="text-white/75 hover:text-white transition-colors" data-id="element-77">
                  Nakup
                </a>
              </li>
              <li data-id="element-78">
                <a href="#" className="text-white/75 hover:text-white transition-colors" data-id="element-79">
                  Prodaja
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="text-white/75 hover:text-white transition-colors" data-id="element-81">
                  Novice
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="text-white/75 hover:text-white transition-colors" data-id="element-83">
                  Registrirajte se
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="text-white/75 hover:text-white transition-colors" data-id="element-85">
                  Prijava
                </a>
              </li>
            </ul>
          </div>

          {/* Pomoč */}
          <div data-id="element-86">
            <h3 className="font-semibold mb-4" data-id="element-87">Pomoč</h3>
            <ul className="space-y-3 text-sm" data-id="element-88">
              <li data-id="element-89">
                <a href="#kako-deluje" className="text-white/75 hover:text-white transition-colors" data-id="element-90">
                  Kako deluje?
                </a>
              </li>
              <li data-id="element-91">
                <a href="#" className="text-white/75 hover:text-white transition-colors" data-id="element-92">
                  Kako kupiti?
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="text-white/75 hover:text-white transition-colors" data-id="element-94">
                  Kako prodati?
                </a>
              </li>
              <li data-id="element-95">
                <a href="#faq" className="text-white/75 hover:text-white transition-colors" data-id="element-96">
                  Pogosta vprašanja
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="text-white/75 hover:text-white transition-colors" data-id="element-98">
                  Kontaktirajte nas
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-99">
            <h3 className="font-semibold mb-4" data-id="element-100">Naročite se na novice</h3>
            <p className="text-white/75 text-sm leading-relaxed mb-4" data-id="element-101">
              Prejmite posodobitve in novice naravnost v svoj nabiralnik, da
              nikoli ne zamudite odličnih priložnosti.
            </p>
            <form onSubmit={e => e.preventDefault()} className="flex items-center gap-2 bg-white/10 rounded-full p-1.5 focus-within:bg-white/15 transition-colors" data-id="element-102">
              <input type="email" placeholder="Vnesite svoj e-poštni naslov" className="flex-1 bg-transparent px-3 py-2 text-sm text-white placeholder-white/60 outline-none min-w-0" aria-label="E-poštni naslov" data-id="element-103" />
              <button type="submit" className="px-5 py-2 bg-[#1EB6E8] hover:bg-[#1aa3d1] text-white text-sm font-medium rounded-full transition-colors whitespace-nowrap" data-id="element-104">
                Naroči se
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/15 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-105">
          <p className="text-sm text-white/70 order-2 md:order-1" data-id="element-106">
            &copy; {new Date().getFullYear()} Podjetje Autopoint APO d.o.o.
          </p>
          <div className="flex items-center gap-4 text-sm text-white/70 order-1 md:order-2" data-id="element-107">
            <a href="#" className="hover:text-white transition-colors" data-id="element-108">
              Pogoji
            </a>
            <span className="text-white/30" data-id="element-109">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-110">
              Zasebnost
            </a>
            <span className="text-white/30" data-id="element-111">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-112">
              Piškotki
            </a>
          </div>
          <div className="flex items-center gap-3 order-3" data-id="element-113">
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-md bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-id="element-114">
              <Instagram className="w-4 h-4" data-id="element-115" />
            </a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-md bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-id="element-116">
              <Facebook className="w-4 h-4" data-id="element-117" />
            </a>
            <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-md bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-id="element-118">
              <Linkedin className="w-4 h-4" data-id="element-119" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}